import { PawPrint, Heart, Users, Share } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 2: Z ikonami i kartami - bardziej wizualny
 */
export const InstagramStoryShare2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top decorative bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Logo */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            marginBottom: "48px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "20px",
              width: "72px",
              height: "72px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "40px", height: "40px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "40px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>

        {/* Main headline */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginBottom: "56px",
          }}
        >
          <h1
            style={{
              fontSize: "88px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.15,
            }}
          >
            Udostępnienie
          </h1>
          <h1
            style={{
              fontSize: "88px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.15,
            }}
          >
            też pomaga 💚
          </h1>
        </div>

        {/* Cards */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            marginBottom: "56px",
          }}
        >
          {/* Card 1 */}
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "28px",
              padding: "32px 40px",
              display: "flex",
              alignItems: "center",
              gap: "24px",
              boxShadow: "0 6px 24px rgba(0,0,0,0.06)",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
                borderRadius: "20px",
                width: "80px",
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Heart style={{ width: "44px", height: "44px", color: "#FFFFFF" }} />
            </div>
            <p
              style={{
                fontSize: "36px",
                fontWeight: 600,
                color: "#2D5A3D",
                margin: 0,
                lineHeight: 1.3,
              }}
            >
              Może ktoś z Twoich znajomych
              <br />
              chce pomóc, tylko nie wie jak
            </p>
          </div>

          {/* Card 2 */}
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "28px",
              padding: "32px 40px",
              display: "flex",
              alignItems: "center",
              gap: "24px",
              boxShadow: "0 6px 24px rgba(0,0,0,0.06)",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
                borderRadius: "20px",
                width: "80px",
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Users style={{ width: "44px", height: "44px", color: "#FFFFFF" }} />
            </div>
            <p
              style={{
                fontSize: "36px",
                fontWeight: 600,
                color: "#2D5A3D",
                margin: 0,
                lineHeight: 1.3,
              }}
            >
              Zbudujmy razem społeczność
              <br />
              pomagającą schroniskom
            </p>
          </div>
        </div>

        {/* Spacer */}
        <div style={{ flex: 1 }} />

        {/* CTA */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "50px",
              padding: "28px 64px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Share style={{ width: "36px", height: "36px", color: "#FFFFFF" }} />
            <span
              style={{
                fontSize: "40px",
                fontWeight: 700,
                color: "#FFFFFF",
              }}
            >
              Udostępnij dalej
            </span>
          </div>

          <span style={{ fontSize: "28px", fontWeight: 600, color: "#6B8A7A" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
